import { SVGICON } from "../../constant/theme";

export const MenuList = [
    {
        title: 'Dashboard',
        iconStyle: SVGICON.MenuDashboard,
        to: '/dashboard',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Racks',
        iconStyle: SVGICON.MenuRack,
        to: '/rack',
        accessRole: ["Admin", "User"],
        permission_key: "manage_rack"
    },
    {
        title: 'Material',
        iconStyle: SVGICON.MenuMaterial,
        to: '/material',
        accessRole: ["Admin", "User"],
        permission_key: "manage_material"
    },
    {
        title: 'Stock History',
        iconStyle: SVGICON.MenuStockHistory,
        to: '/stock_history',
        accessRole: ["Admin", "User"],
        permission_key: "view_stock_history"
    },
    {
        title: 'Barcode',
        iconStyle: SVGICON.MenuBarcode,
        to: '/barcode',
        accessRole: ["Admin", "User"],
        permission_key: "manage_barcode"
    },
    {
        title: 'Employee',
        iconStyle: SVGICON.MenuEmployee,
        to: '/employee',
        accessRole: ["Admin", "User"],
        permission_key: null
    },
    {
        title: 'Report',
        iconStyle: SVGICON.MenuReport,
        to: '/report',
        accessRole: ["Admin", "User"],
        permission_key: "view_report"
    },
    {
        title: 'User',
        iconStyle: SVGICON.MenuUsers,
        to: '/user',
        accessRole: ["Admin"],
        permission_key: null
    },
    {
        title: 'Demand Forecast',
        iconStyle: SVGICON.Reports,
        to: '/demand-forecast',
        accessRole: ["Admin", "User"],
        permission_key: "view_demand_forecast"
    },
    {
        title: 'Analysis',
        iconStyle: SVGICON.Charts,
        to: '/analysis',
        accessRole: ["Admin", "User"],
        permission_key: "view_analysis"
    },
    {
        title: 'Purchase Demand',
        iconStyle: SVGICON.Reports,
        to: '/purchase-demand',
        accessRole: ["Admin", "User"],
        permission_key: "view_purchase_demand"
    }

]